// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2l_Xs","inner":"Form_inner__2uTWu","range":"Form_range__3VTzP","name":"Form_name__kBTkN","actions":"Form_actions__2arel"};